import React, { useState, createContext } from 'react';

export const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
  const [deviceToken, setDeviceToken] = useState('')

  document.addEventListener("deviceready", () => {
    console.log('DEVICE IS READY');
    if (window.FirebasePlugin) {
      console.log('FIREBASE LOADED');
      window.FirebasePlugin.grantPermission();
      window.FirebasePlugin.onTokenRefresh(function(token) {
          // save this server-side and use it to push notifications to this device
          console.log('--------------------');
          console.log(token);
          console.log('---------------------');
          setDeviceToken(token)

      }, function(error) {
          console.error(error);
      });
    } else {
      console.log('FIREBASE DID NOT LOAD');
    }
  });

  return (
    <NotificationContext.Provider
      value={{
        deviceToken,
      }}
    >
      {children}
    </NotificationContext.Provider>
  );
};

export const withNotification = Component => props => (
  <NotificationContext.Consumer>
    {context => <Component {...props} notificationContext={context} />}
  </NotificationContext.Consumer>
);

// const [saveToken] = useMutation(SAVE_DEVICE_TOKEN)

// const saveToken = (token, platform, user, saveToken) => {
//   saveToken(
//     {
//       variables:
//       {
//         userId: user.email,
//         platform,
//         fcmToken: token
//       },
//       onCompleted: data => {
//
//       }
//     })
//   .then(res => {
//     console.log(res)
//     console.log('COMPLETED')
//     return {status: 'OK'}
//   })
//   .catch(e => {
//     console.log(e.message)
//     //setErrorMessage('Payment Failed')
//     return {status: 'ERROR', message: e.message}
//   })
// }
//
// const SAVE_DEVICE_TOKEN = gql`
//   mutation SaveDeviceToken($userId: ID!, $token: String!, $pltform: String) {
//     saveDeviceToken(userId: $userId, token: $token, platform: $platform) {
//       status
//       code
//       message
//     }
//   }
// `
